import { pazienHistory } from "common/components/pazienHistory";

import { UPDATE_FILTERS, SET_STATE_FROM_URL } from "../reducers/sessions";

export const SESSIONS_SET_STATE_FROM_URL = function(data) {
    return (dispatch, getState) => {
        dispatch(SET_STATE_FROM_URL(data));
    
        // And immediately update the url with any defaults
        pazienHistory.navigateWithParams(`administrator/sessions/${window.encodeURIComponent(getState().sessions.qualifiers)}`);
    };
};

export const SESSIONS_UPDATE_FILTERS = function(qualifiers) {
    return (dispatch, getState) => {
        dispatch(UPDATE_FILTERS({
            qualifiers: qualifiers.toString()
        }));
    
        pazienHistory.navigateWithParams(`administrator/sessions/${window.encodeURIComponent(getState().sessions.qualifiers)}`);
    };
};
